export default __webpack_public_path__ + "static/media/features-price.2c1ff532.svg";